import Link from "next/link";
import { useOfferMode } from "@nju/data-access-portal-offers";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, Panel, Separator, Text } from "@nju/ui";
import { generalErrorMessage } from "@nju/utils";

export function PayByLinkError() {
  const mode = useOfferMode();

  return (
    <Panel>
      <div className="flex items-center flex-col">
        <Text
          size={{
            "@onlyMobile": "xl",
            "@fromTablet": "keyM",
          }}
          weight="bold"
        >
          {generalErrorMessage}
        </Text>
        <Separator size="s" tone="invisible" />
        <Icon
          className="w-12 h-12 from-tablet:w-[90px] from-tablet:h-[90px]"
          name="money-bill-incircle-fail"
        />
        <Separator size="s" tone="invisible" />
        <Text
          align="center"
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "l",
          }}
        >
          Nie możemy zrealizować płatności
        </Text>
      </div>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center">
        <Link href={portalRoutes.mojeKonto.index.get({ mode })} passHref={true}>
          <A
            size={{
              "@onlyMobile": "s",
            }}
          >
            spróbuj ponownie
          </A>
        </Link>
      </div>
    </Panel>
  );
}
